var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('sidebar',[_vm._t("header")],2),_c('Appbar'),_c('v-main',{attrs:{"id":"content"}},[_c('v-container',{attrs:{"fluid":"","pa-0":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }